import React from "react";
import { createPortal } from "react-dom";
import { PulseLoader } from "react-spinners";

export default function FullScreenOverlay({ active = false }) {
    const color = "white";

    if (!active) return null;
    return createPortal(
        <div className="fs-overlay" role="alert" aria-busy="true" aria-live="polite">
            <div className="fs-overlay__box">
                <PulseLoader
                    color={color}
                    loading={active}
                    size={30}
                    speedMultiplier={1}
                />
            </div>
        </div>,
        document.body
    );
}